//tdm = tag der Admin
import api from './services/mkm.api.js'

const resource = '/TDAAnmeldung'

export default {
    senden(payload) {
        return api.post(`${resource}`, payload)
    },
}